@switch (type) {
  @case ('default') {
    <ng-template *ngTemplateOutlet="defaultInput"></ng-template>
  }
  @case ('color') {
    <ng-template *ngTemplateOutlet="colorInput"></ng-template>
  }
  @case ('v2') {
    <ng-template *ngTemplateOutlet="v2Input"></ng-template>
  }
  @case ('date') {
    <ng-template *ngTemplateOutlet="dateInput"></ng-template>
  }
}

<ng-template #defaultInput>
  <div class="d-flex flex-column">
    @if (label) {
      <div class="label" [ngClass]="{ 'text-danger': error }">
        {{ label }}
        @if (required) {
          <span>*</span>
        }
      </div>
    }
    <div class="d-flex flex-row">
      <input
        #inputRef
        matInput
        [id]="id"
        [name]="name"
        [type]="isPassword && hide ? 'password' : 'text'"
        [mask]="mask"
        [prefix]="prefix"
        [suffix]="suffix"
        [min]="min"
        [max]="max"
        [placeholder]="placeholder"
        [maxlength]="maxLength"
        [readonly]="readonly"
        autocomplete="off"
        [ngClass]="{ 'disabled-input': disabled, 'error-input': error, 'without-right-border': isPassword }"
        [ngModel]="input"
        [disabled]="disabled"
        (keydown)="clickKey($event)"
        (ngModelChange)="onchange($event)"
        class="input-default w-100 {{ customClass }}"
      />
      @if (isPassword) {
        <button (click)="hide = !hide" class="btn-as-input">
          <app-icon>{{ hide ? 'visibility' : 'visibility_off' }}</app-icon>
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #colorInput>
  <div class="d-flex flex-column">
    @if (label) {
      <label class="label" [ngClass]="{ 'text-danger': error }">
        {{ label }}
        @if (required) {
          <span style="color: red">*</span>
        }
      </label>
    }
    <input
      #inputRef
      matInput
      type="color"
      [placeholder]="placeholder"
      [(ngModel)]="input"
      (ngModelChange)="onchange($event)"
      [ngClass]="{ 'input-color': true }"
    />
  </div>
</ng-template>

<ng-template #v2Input>
  <mat-form-field class="w-100 {{ customClass }}" appearance="outline">
    @if (label) {
      <mat-label>{{ label | translate }}</mat-label>
    }
    <input
      #inputRef
      matInput
      class="w-100"
      [formControl]="formControl"
      [type]="inputType"
      [min]="min"
      [max]="max"
      [id]="id"
      [name]="name"
      [mask]="mask"
      [prefix]="prefix"
      [suffix]="suffix"
      [placeholder]="isPlaceholderTranslate ? (placeholder | translate) : placeholder"
      [maxlength]="maxLength"
      [readonly]="readonly"
      autocomplete="off"
      [disabled]="disabled"
    />
    @if (formControl && formControl.touched && formControl.invalid) {
      <mat-error>
        @if (formControl.hasError('required')) {
          {{ 'input_errors.required' | translate }}
        }
        @if (formControl.hasError('maxlength')) {
          {{
            'input_errors.maxlength'
              | translate: { value: $safeNavigationMigration(formControl.errors?.['maxlength'].requiredLength) }
          }}
        }
        @if (formControl.hasError('minlength')) {
          {{
            'input_errors.minlength'
              | translate: { value: $safeNavigationMigration(formControl.errors?.['minlength'].requiredLength) }
          }}
        }
        @if (formControl.hasError('max')) {
          {{ 'input_errors.max' | translate: { value: $safeNavigationMigration(formControl.errors?.['max'].max) } }}
        }
        @if (formControl.hasError('min')) {
          {{ 'input_errors.min' | translate: { value: $safeNavigationMigration(formControl.errors?.['min'].min) } }}
        }
        @if (formControl.hasError('phone_invalid_length')) {
          {{ 'input_errors.phone_invalid_length' | translate }}
        }
        @if (formControl.hasError('time_in_past')) {
          {{ 'input_errors.time_in_past' | translate }}
        }
        @if (formControl.hasError('some_field_required')) {
          {{ 'input_errors.some_field_required' | translate }}
        }
      </mat-error>
    }
    @if (formControl && typeof formControl.value === 'string' && maxLength) {
      <mat-hint align="end"> {{ formControl.value.length || 0 }}/{{ maxLength }} </mat-hint>
    }
  </mat-form-field>
</ng-template>

<ng-template #dateInput>
  <mat-form-field class="w-100" appearance="outline">
    @if (label) {
      <mat-label>{{ label | translate }}</mat-label>
    }
    <input
      matInput
      [matDatepicker]="picker"
      class="w-100"
      [formControl]="formControl"
      [min]="min"
      [max]="max"
      [id]="id"
      [name]="name"
      [placeholder]="placeholder | translate"
      [readonly]="readonly"
      [disabled]="disabled"
      (dateChange)="onDateChange($event)"
    />
    <mat-hint [hidden]="true">DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker" />
    <mat-datepicker #picker [disabled]="disabled || (formControl && formControl.disabled)" />
    @if (formControl.touched && formControl.invalid) {
      <mat-error>
        @if (formControl.hasError('required')) {
          {{ 'input_errors.required' | translate }}
        }
        @if (formControl.hasError('date_in_past')) {
          {{ 'input_errors.date_in_past' | translate }}
        }
      </mat-error>
    }
  </mat-form-field>
</ng-template>
